export function shortHash(h, head = 8, tail = 6) {
    if (!h) return "";
    if (h.length <= head + tail + 3) return h;
    return `${h.slice(0, head)}…${h.slice(-tail)}`;
}

export function HashChip({ value, testid, className = "" }) {
    return (
        <span
            data-testid={testid}
            title={value}
            className={`hash-mono inline-flex items-center px-2 py-0.5 rounded-sm bg-civic-50 text-civic-700 border border-civic-100 ${className}`}
        >
            {shortHash(value)}
        </span>
    );
}
